import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { TableSection, Pagination } from 'components';
import { useAPI, useDebounce } from 'hooks';
import { getUserName } from 'helpers';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Eye } from 'lucide-react';

const PilgrimsPage = () => {
  const { api } = useAPI();
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const debouncedSearchQuery = useDebounce(search, 1000);
  const itemsPerPage = 5;
  const limit = 30;

  const fetchParams = search.length > 0 ? { q: debouncedSearchQuery } : { limit };

  const { data: trips } = useQuery({
    queryFn: api.list('trip/', fetchParams),
    queryKey: ['trip/', debouncedSearchQuery, limit],
    keepPreviousData: true,
  });

  const totalPages = trips ? Math.ceil(trips.length / itemsPerPage) : 1;
  const startIndex = (page - 1) * itemsPerPage;
  const currentPageData = trips ? trips.slice(startIndex, startIndex + itemsPerPage) : [];

  const nextPage = () => setPage((p) => Math.min(p + 1, totalPages));
  const prevPage = () => setPage((p) => Math.max(p - 1, 1));

  const statusVariant = (category) => {
    let result = 'bg-gray-100 text-gray-800 border-gray-300';

    if (category === 'Premium') {
      result = 'bg-blue-100 text-blue-800 border-blue-300';
    } else if (category === 'Elite') {
      result = 'bg-yellow-100 text-yellow-800 border-yellow-300';
    } else if (category.includes('Diaspora')) {
      result = 'bg-green-100 text-green-800 border-green-300';
    }

    return result;
  };

  return (
    <TableSection
      title="Liste des Pèlerins"
      description="Gérez les informations essentielles des pèlerins"
      onSearch={(value) => setSearch(value.trim())}
      searchPlaceholder="Rechercher un pèlerin..."
    >
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Pèlerins</TableHead>
            <TableHead>NPI</TableHead>
            <TableHead>Catégorie</TableHead>
            <TableHead>Détails</TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {currentPageData.map((trip) => (
            <TableRow key={trip.id} className="hover:bg-gray-50">
              <TableCell className="font-medium">
                {getUserName(trip.pilgrim.first_name, trip.pilgrim.last_name)}
              </TableCell>
              <TableCell>{trip.pilgrim.npi || '-'}</TableCell>
              <TableCell>
                <Badge variant="outline" className={`${statusVariant(trip.category_name)} rounded-full`}>
                  {trip.category_name}
                </Badge>
              </TableCell>
              <TableCell>
                <Button variant="outline" size="sm" className="flex items-center gap-1">
                  <Eye className="w-4 h-4" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Pagination page={page} totalPages={totalPages} onPrev={prevPage} onNext={nextPage} />
    </TableSection>
  );
};

export default PilgrimsPage;
